import { createRouter, createWebHashHistory } from 'vue-router';
import { useAuthStore } from '@/stores/auth';
import { useUserStore } from '@/stores/user';
const routes = [
    // 登录页面路由
    {
        path: '/admin-login',
        name: 'AdminLogin',
        component: () => import('@/views/common/AdminLogin.vue'),
        meta: { requiresAuth: false }
    },
    {
        path: '/agent-login',
        name: 'AgentLogin',
        component: () => import('@/views/common/AgentLogin.vue'),
        meta: { requiresAuth: false }
    },
    {
        path: '/user-login',
        name: 'UserLogin',
        component: () => import('@/views/common/UserLogin.vue'),
        meta: { requiresAuth: false }
    },
    {
        path: '/invite',
        name: 'InviteRegister',
        component: () => import('@/views/common/InviteRegister.vue'),
        meta: { requiresAuth: false }
    },
    {
        path: '/register',
        name: 'Register',
        component: () => import('@/views/common/InviteRegister.vue'),
        meta: { requiresAuth: false }
    },
    {
        path: '/login',
        redirect: '/agent-login'
    },
    // 管理员路由
    {
        path: '/admin',
        name: 'AdminLayout',
        component: () => import('@/views/admin/Layout.vue'),
        meta: { requiresAuth: true, userType: 'admin' },
        redirect: '/admin/dashboard',
        children: [
            {
                path: 'dashboard',
                name: 'AdminDashboard',
                component: () => import('@/views/admin/Dashboard.vue'),
                meta: { title: '控制台' }
            },
            {
                path: 'agents',
                name: 'AdminAgents',
                component: () => import('@/views/admin/Agents.vue'),
                meta: { title: '代理管理' }
            },
            {
                path: 'users',
                name: 'AdminUsers',
                component: () => import('@/views/admin/Users.vue'),
                meta: { title: '用户管理' }
            },
            {
                path: 'user-coins',
                name: 'AdminUserCoins',
                component: () => import('@/views/admin/AdminUserCoins.vue'),
                meta: { title: '用户金币' }
            },
            {
                path: 'cards',
                name: 'AdminCards',
                component: () => import('@/views/agent/Cards.vue'),
                meta: { title: '卡密管理' }
            },
            {
                path: 'card-types',
                name: 'AdminCardTypes',
                component: () => import('@/views/admin/CardTypes.vue'),
                meta: { title: '卡密类型' }
            },
            {
                path: 'balance',
                name: 'AdminBalance',
                component: () => import('@/views/admin/BalanceManagement.vue'),
                meta: { title: '余额管理' }
            },
            {
                path: 'financial-reports',
                name: 'AdminFinancialReports',
                component: () => import('@/views/admin/FinancialReports.vue'),
                meta: { title: '财务报表' }
            },
            {
                path: 'reports',
                redirect: 'financial-reports'
            },
            {
                path: 'device-management',
                name: 'AdminDeviceManagement',
                component: () => import('@/views/admin/DeviceManagement.vue'),
                meta: { title: '设备管理' }
            },
            {
                path: 'app-management',
                name: 'AdminAppManagement',
                component: () => import('@/views/admin/AppManagement.vue'),
                meta: { title: 'APP管理' }
            },
            {
                path: 'app-versions',
                name: 'AdminAppVersions',
                component: () => import('@/views/admin/AppVersions.vue'),
                meta: { title: 'APP版本管理' }
            },
            {
                path: 'system-logs',
                name: 'AdminSystemLogs',
                component: () => import('@/views/admin/SystemLogs.vue'),
                meta: { title: '系统日志' }
            },
            {
                path: 'logs',
                name: 'AdminLogs',
                component: () => import('@/views/admin/Logs.vue'),
                meta: { title: '激活日志' }
            },
            {
                path: 'settings',
                name: 'AdminSettings',
                component: () => import('@/views/admin/Settings.vue'),
                meta: { title: '系统设置' }
            },
            {
                path: 'profile',
                name: 'AdminProfile',
                component: () => import('@/views/common/Profile.vue'),
                meta: { title: '个人资料' }
            },
            {
                path: 'notifications',
                name: 'AdminNotifications',
                component: () => import('@/views/common/Notifications.vue'),
                meta: { title: '消息中心' }
            }
        ]
    },
    // 代理路由
    {
        path: '/agent',
        name: 'AgentLayout',
        component: () => import('@/views/agent/Layout.vue'),
        meta: { requiresAuth: true, userType: 'agent' },
        redirect: '/agent/dashboard',
        children: [
            {
                path: 'dashboard',
                name: 'AgentDashboard',
                component: () => import('@/views/agent/Dashboard.vue'),
                meta: { title: '控制台' }
            },
            {
                path: 'users',
                name: 'AgentUsers',
                component: () => import('@/views/agent/Users.vue'),
                meta: { title: '用户管理' }
            },
            {
                path: 'user-coins',
                name: 'AgentUserCoins',
                component: () => import('@/views/agent/UserCoins.vue'),
                meta: { title: '用户金币' }
            },
            {
                path: 'cards',
                name: 'AgentCards',
                component: () => import('@/views/agent/Cards.vue'),
                meta: { title: '卡密管理' }
            },
            {
                path: 'purchase',
                name: 'AgentPurchase',
                component: () => import('@/views/agent/Purchase.vue'),
                meta: { title: '购买卡密' }
            },
            {
                path: 'invite',
                name: 'AgentInvite',
                component: () => import('@/views/agent/Invite.vue'),
                meta: { title: '邀请用户' }
            },
            {
                path: 'reports',
                name: 'AgentReports',
                component: () => import('@/views/agent/Reports.vue'),
                meta: { title: '报表统计' }
            },
            {
                path: 'logs',
                name: 'AgentLogs',
                component: () => import('@/views/admin/Logs.vue'),
                meta: { title: '激活日志' }
            },
            {
                path: 'profile',
                name: 'AgentProfile',
                component: () => import('@/views/common/Profile.vue'),
                meta: { title: '个人资料' }
            },
            {
                path: 'notifications',
                name: 'AgentNotifications',
                component: () => import('@/views/common/Notifications.vue'),
                meta: { title: '消息中心' }
            }
        ]
    },
    // 用户路由
    {
        path: '/user',
        name: 'UserLayout',
        component: () => import('@/views/user/Layout.vue'),
        meta: { requiresAuth: true, userType: 'user' },
        redirect: '/user/dashboard',
        children: [
            {
                path: 'dashboard',
                name: 'UserDashboard',
                component: () => import('@/views/user/UserDashboard.vue'),
                meta: { title: '个人中心' }
            },
            {
                path: 'cards',
                name: 'UserCards',
                component: () => import('@/views/user/UserCards.vue'),
                meta: { title: '我的卡密' }
            },
            {
                path: 'coins',
                name: 'UserCoins',
                component: () => import('@/views/user/UserCoins.vue'),
                meta: { title: '金币记录' }
            },
            {
                path: 'devices',
                name: 'UserDevices',
                component: () => import('@/views/user/UserDevices.vue'),
                meta: { title: '设备管理' }
            },
            {
                path: 'profile',
                name: 'UserProfile',
                component: () => import('@/views/common/Profile.vue'),
                meta: { title: '个人资料' }
            }
        ]
    },
    // 兼容旧路由的重定向
    {
        path: '/',
        redirect: '/agent-login'
    },
    // 教程公共路由(所有已登录角色可访问)
    {
        path: '/tutorials',
        name: 'TutorialList',
        component: () => import('@/views/common/TutorialList.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/tutorials/:id',
        name: 'TutorialDetail',
        component: () => import('@/views/common/TutorialDetail.vue'),
        meta: { requiresAuth: true }
    },
    // 独立教程中心 jc 路由
    {
        path: '/jc',
        component: () => import('@/views/jc/Layout.vue'),
        meta: { requiresAuth: true },
        redirect: '/jc/list',
        children: [
            {
                path: 'list',
                name: 'JcList',
                component: () => import('@/views/jc/List.vue'),
                meta: { title: '教程列表' }
            },
            {
                path: 'detail/:id',
                name: 'JcDetail',
                component: () => import('@/views/jc/Detail.vue'),
                meta: { title: '教程详情' }
            }
        ]
    },
    // 兼容旧的路由路径
    {
        path: '/dashboard',
        redirect: '/admin/dashboard'
    },
    {
        path: '/agents',
        redirect: '/admin/agents'
    },
    {
        path: '/users',
        redirect: '/admin/users'
    },
    {
        path: '/cards',
        redirect: '/admin/cards'
    }
];
const router = createRouter({
    history: createWebHashHistory(),
    routes: routes
});
router.beforeEach((to, from, next) => {
    const authStore = useAuthStore();
    const userStore = useUserStore();
    // 确保认证状态已检查
    authStore.checkAuth();
    const isAuthenticated = authStore.isAuthenticated;
    const userType = authStore.userType;
    const isUserAuthenticated = userStore.isLoggedIn();
    // 登录页面路径集合
    const loginPaths = ['/admin-login', '/agent-login', '/user-login'];
    // 如果访问登录页面且已登录，重定向到对应首页
    if (loginPaths.includes(to.path)) {
        if (isUserAuthenticated) {
            return next('/user/dashboard');
        }
        else if (isAuthenticated) {
            // 根据用户类型重定向到对应的首页
            if (userType === 'admin') {
                return next('/admin/dashboard');
            }
            else if (userType === 'agent') {
                return next('/agent/dashboard');
            }
        }
        return next();
    }
    // 处理用户路由
    if (to.path.startsWith('/user')) {
        if (!isUserAuthenticated) {
            return next('/user-login');
        }
        return next();
    }
    // 处理管理员路由
    if (to.path.startsWith('/admin')) {
        if (!isAuthenticated || userType !== 'admin') {
            return next('/admin-login');
        }
        return next();
    }
    // 处理代理路由
    if (to.path.startsWith('/agent')) {
        if (!isAuthenticated || userType !== 'agent') {
            return next('/agent-login');
        }
        return next();
    }
    // 邀请注册页面
    if (to.path === '/invite' || to.path === '/invite-register') {
        return next();
    }
    // 兼容旧路由的处理
    if (to.path === '/') {
        if (isUserAuthenticated) {
            return next('/user/dashboard');
        }
        else if (isAuthenticated) {
            if (userType === 'admin') {
                return next('/admin/dashboard');
            }
            else if (userType === 'agent') {
                return next('/agent/dashboard');
            }
        }
        return next('/agent-login');
    }
    // 其他需要认证的页面
    if (to.meta?.requiresAuth !== false && !isAuthenticated && !isUserAuthenticated) {
        return next('/agent-login');
    }
    next();
});
export default router;
